import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import classnames from "classnames";
import styles from "./styles.css";

interface AppStoreDetailsProps {
    className?: string;
}

export default function AppStoreDetails({ className }: AppStoreDetailsProps): JSX.Element {
    return (
        <div className={classnames(styles.appStoreDetails, className)}>
            <p>{gettext("app_landing.rating.number")}</p>
            <div className={styles.stars}>
                <SVGIcon name="stars" />
            </div>
            <p className={styles.rating}>{gettext("app_landing.rating.label")}</p>
        </div>
    );
}
